import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {openDialog} from "../../../../store/actionCreators/dialog";

const UnionNotice =({ action }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [agreeWithTerms, setAgreeWithTerms] = useState(false);

    const openUnionDialog = () => {
        if( agreeWithTerms ) {
            dispatch(openDialog(`${action}Union`, {title: `${action}Union`}));
        }
    };

    return (
        <React.Fragment>
            <div className="termsText">
                <p>{t('dialog.unionTerms.one')}</p>
                <br />
                <p>{t('dialog.unionTerms.two')}</p>
                <label className={`checkboxContainer`}>
                    <input type="checkbox" onChange={e => setAgreeWithTerms(e.target.value)}/>
                    <span className="checkmark"></span> {t('dialog.unionTerms.agreement')}
                </label>
            </div>
            <div className="dialogConfirmBox">
                <button onClick={() => openUnionDialog()} className={'primary'} disabled={!agreeWithTerms}>
                    {t('button.confirm')}
                </button>
            </div>
        </React.Fragment>
    );
};

export default UnionNotice;

